<template>

    <Page>

        <div class="grid grid-cols-2 gap-8">

            <div class="flex flex-col items-center">
                <Image 
                    src="/Challenge/goodwill.png" 
                    image-class="rounded-md"
                    floor-shadow
                />
                <div class="mt-6 flex flex-col items-center px-14">
                    <h2 class="mb-4 text-lg">Your goodwill is your leverage - protect it</h2>
                    <p class="font-normal text-white/60 text-center mb-4">
                        All industry stakeholders are competing fiercely for 
                        consumer ownership, leading to significant erosion of
                        goodwill value.
                    </p>
                    <p class="font-normal text-white/60 text-center">
                        The dealership is not always the consumers' first thought
                        for minor repair work and maintenance.
                    </p>
                </div>
            </div>

            <div class="flex flex-col items-center">
                <Image
                    src="/Challenge/uncertain-future.png" 
                    image-class="rounded-md" 
                    floor-shadow
                />
                <div class="mt-6 flex flex-col items-center px-14">
                    <h2 class="mb-4 text-lg">Dealer revenue is under attack!</h2>
                    <p class="font-normal text-white/60 text-center">
                        We are experiencing soft market conditions,
                        currently in decline and forecast to get worse.
                    </p>
                </div>
            </div>

        </div>
    
    </Page>

</template>